export default __webpack_public_path__ + "static/media/unselected5.cae75ec3.png";